<div class="h-100">
    <app-buscador-productos></app-buscador-productos>

    <mdc-drawer #sideMenu [drawer]="globals.drawerObject.tipo" [open]="globals.drawerObject.open" (window:resize)="onResize($event)" (closed)="cerrarModal()">
        <mdc-drawer-content>
            <mdc-list>
                <a mdc-list-item routerLink="/" routerLinkActive #itemCategorias="routerLinkActive" [activated]="itemCategorias.isActive" [routerLinkActiveOptions]="{exact: true}" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>home</mdc-icon>Inicio
                </a>
                <a mdc-list-item routerLink="/catalogo" routerLinkActive #itemHome="routerLinkActive" [activated]="itemHome.isActive" [routerLinkActiveOptions]="{exact: true}" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>format_list_numbered</mdc-icon>Catálogo
                </a>
                <a mdc-list-item routerLink="/cotizar" routerLinkActive #itemCotizar="routerLinkActive" [activated]="itemCotizar.isActive" [routerLinkActiveOptions]="{exact: true}" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>point_of_sale</mdc-icon>Cotizar
                </a>
                <a mdc-list-item routerLink="/cotizaciones" routerLinkActive #itemCotizaciones="routerLinkActive" [activated]="itemCotizaciones.isActive" [routerLinkActiveOptions]="{exact: true}" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>list_alt</mdc-icon>Cotizaciones
                </a>
                <a mdc-list-item routerLink="/catalogo/mayor" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>sell</mdc-icon>Precios al Mayor
                </a>
                <a mdc-list-item routerLink="/catalogo/detal" (click)="cerrarModal()">
                    <mdc-icon mdcListItemGraphic>sell</mdc-icon>Precios al detal
                </a>
            </mdc-list>
        </mdc-drawer-content>
    </mdc-drawer>

    <div mdcDrawerAppContent class="h-100 position-relative">
        <router-outlet></router-outlet>
    </div>
</div>
<app-bottom-navigation></app-bottom-navigation>
